import React from 'react';
import 'assets/scss/portabilidad-header.scss';

type MultiFormCardHeaderProps = {
	title: string;
	body: any;
};

export const MultiFormCardHeader = ({ title, body }: MultiFormCardHeaderProps) => {
	return (
		<div className="portabilidadheader-container">
			<h1 className="title-4 new-title-color">{title}</h1>
			<div className="subtitle-1 gris-6">{body}</div>
		</div>
	);
};
